<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>Menu Favorit</h2>

      <br />

      <div class="filter">
        <div class="form-group">
          <label for="">Filter Tanggal</label>
          <date-range-picker v-model="dateRange">
            <template v-slot:input="picker">
              {{ moment(picker.startDate).format("DD MMM YYYY") }} -
              {{ moment(picker.endDate).format("DD MMM YYYY") }}
            </template>
          </date-range-picker>
        </div>
        <div class="form-group">
          <label>&nbsp;</label>
          <button type="button" class="btn-fill" @click="loadData">
            Filter
          </button>
        </div>
        <div></div>
        <div class="form-group">
          <label>Export Data</label>
          <button
            type="button"
            class="btn-outline green"
            @click="exportExcel()"
          >
            Export Excel
          </button>
        </div>
      </div>

      <table class="table">
        <thead>
          <tr>
            <th style="width: 50px">No</th>
            <th>Menu</th>
            <th>Jumlah Terjual</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ ++index }}</td>
            <td>{{ item.menu }}</td>
            <td>{{ item.total }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import * as api from "../../api/Api";
import moment from "moment";

export default {
  components: {
    DateRangePicker,
  },
  name: "Menu Favorit",
  data() {
    return {
      loading: false,
      data: [],
      dateRange: {
        startDate: moment().format("YYYY-MM-01"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      filter: {
        id_toko: this.$toko.id,
        tgl_awal: moment().format("YYYY-MM-01"),
        tgl_akhir: moment().format("YYYY-MM-DD"),
      },
    };
  },
  methods: {
    moment,
    loadData() {
      this.loading = true;

      this.filter.tgl_awal = moment(this.dateRange.startDate).format(
        "YYYY-MM-DD"
      );
      this.filter.tgl_akhir = moment(this.dateRange.endDate).format(
        "YYYY-MM-DD"
      );

      api
        .get(
          "/v4/laporan/penjualan/menu-favorit?" +
            this.$objectToQuery(this.filter)
        )
        .then((r) => {
          this.loading = false;
          this.data = r.data;
        })
        .catch((e) => {
          this.loading = false;
          this.openFilter = false;
        });
    },
    exportExcel() {
      this.loadingExcel = true;
      const payload = this.data;

      const tgl_awal = moment(this.dateRange.startDate).format("YYYY-MM-DD");
      const tgl_akhir = moment(this.dateRange.endDate).format("YYYY-MM-DD");

      api
        .postJson(
          "https://app.restoku.id/exporter/menuFavorit?id_toko=" +
            this.$toko.id +
            "&title=Laporan Menu Favorit" +
            "&tgl_awal=" +
            tgl_awal +
            "&tgl_akhir=" +
            tgl_akhir,
          payload
        )
        .then((r) => {
          if (r.valid) {
            location.href = r.url;
          }

          this.loadingExcel = false;
        })
        .catch((e) => {
          this.$toast("Terjadi kesalahan");
          this.loadingExcel = false;
        });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
  }

  .filter {
    display: grid;
    grid-template-columns: 240px 150px 1fr 150px;
    grid-column-gap: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #ccc;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/laporan/MenuFavorit.vue